import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import eq from 'eq.js';
import { getAutoGridCSS } from '../util';
var propTypes = {
  /**
   specifies if the grid should automatically layout equally sized and distributed child element without Columns
   this property can be either a boolean value that will use the default settings in case it is set to true or
   an object that can contain a minWidth property that defines the minimum width that each child of the grid can have
   and can also contain a gridGap property that will be responsible to define the gap between each child of the grid.
  */
  auto: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),

  /**
   specifies if the grid is rendered without padding on the right and left
  */
  full: PropTypes.bool,

  /**
   additional style class(es)
  */
  className: PropTypes.string,

  /**
   child elements
  */
  children: PropTypes.node.isRequired
};
var defaultProps = {
  auto: false,
  full: false,
  className: undefined
};
/**
 * Column container aka Grid.
 * You should put columns inside a Grid
 * @param {[bool]} auto defaults to false
 * @param {[bool]} full defaults to false -- if true, removes padding
 * @param {[node]} children Children
 * @returns {[node]} the rendered DOM node
 */

var Grid = function Grid(props) {
  var auto = props.auto,
      full = props.full,
      children = props.children,
      className = props.className,
      otherProps = _objectWithoutProperties(props, ["auto", "full", "children", "className"]);

  var gridRef = useRef(null);
  useEffect(function () {
    if (auto) eq.query([gridRef.current]);
  });
  var stylingClass = classNames('wds-l-grid', {
    'wds-l-grid--full': full,
    'wds-l-grid--auto': auto
  }, className);
  var autoGridClassname = 'wds-l-grid--auto_class';
  var autoGridStyle;

  if (auto && _typeof(auto) === 'object' && (auto.minWidth || auto.gridGap)) {
    if (auto.minWidth) autoGridClassname += "_".concat(auto.minWidth);
    if (auto.gridGap) autoGridClassname += "_".concat(auto.gridGap);
    stylingClass += " ".concat(autoGridClassname);
    autoGridStyle = getAutoGridCSS(autoGridClassname, auto.minWidth, auto.gridGap);
  }

  var hasColumns = React.Children.map(children, function (child) {
    return child && child.type && child.type.displayName === 'Column' && child;
  }).filter(function (el) {
    return el;
  }).length > 0;

  if (auto && hasColumns) {
    console.warn("Grid auto variant shouldn't be used with Columns.");
  }

  var dataEqPts = {
    'data-eq-pts': "aboveMin: ".concat(auto.minWidth)
  };
  return React.createElement(React.Fragment, null, autoGridStyle && React.createElement("style", null, autoGridStyle), React.createElement("div", _extends({
    ref: gridRef
  }, auto.minWidth && dataEqPts, {
    className: stylingClass
  }, otherProps), auto ? React.createElement("div", {
    className: "wds-l-grid--auto__margin-fix"
  }, children) : children));
};

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;
Grid.displayName = 'Grid';
export default Grid;